<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p v-if="isLoading" class="modal-card-title">
                Preview is loading
                <i class="fa fa-spinner fa-spin loading-icon fa-2x fa-fw"></i>
            </p>
            <p v-else class="modal-card-title">{{ file.name }}</p>
        </header>
        <section class="modal-card-body has-text-centered">
            <div v-if="isLoading || (!!file && file.loading)">
                <o-icon icon="spinner" size="is-small" custom-class="fa-spin" />
                <span>Loading...</span>
            </div>
            <template v-else-if="!!file">
                <embed
                    align="middle"
                    class="file-preview"
                    ref="embed"
                    v-if="file.type === 'application/pdf'"
                    :src="preview_path"
                />
                <img
                    v-else-if="file.type.startsWith('image')"
                    :src="file.data_url || preview_path"
                    :alt="file.name"
                />
                <div v-else>
                    <i class="fa fa-file fa-5x"></i>
                    <p class="m-10">
                        <span>This file can't be previewed</span>
                        <br />
                    </p>
                </div>
                <a
                    :href="file.data_url"
                    class="button is-success is-fullwidth m-10"
                    :download="file.name"
                    >Download</a
                >
            </template>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">
                Close
            </button>
            <div class="action-button-container" v-if="actionButton">
                <button
                    @click.prevent="actionButton.handler"
                    class="button is-pulled-right is-success"
                >
                    {{ actionButton.label }}
                </button>
            </div>
        </footer>
    </div>
</template>

<script>
import { fetch_file } from '../../gmail_api'
export default {
     props: ['action-button', 'file'],
    computed: {
        preview_path() {
            if(/^https:\/\/ucarecdn\.com/.test(this.file.data_url)) {
                return `https://drive.google.com/viewerng/viewer?embedded=true&url=${this.file.data_url}`
            }
            return this.file.data_url
        },
    },
    data() {
        return {
            isLoading: true,
            image_url: '',
        }
    },
    methods: {
        load() {
            this.isLoading = true
            if (!this.file.loading) {
                fetch_file(this.file).then(() => {
                    this.isLoading = false
                    this.$forceUpdate()
                }).catch(() => {
                    this.isLoading = false
                    this.$forceUpdate()
                })
            }
        },
    },
    mounted() {
        // this.load()

        this.image_url = this.file.data_url.replace(`data${this.file.type}base64`, `data:${this.file.type};base64,`)
      this.isLoading = false
    },
    watch: {
        'file.loading'(value) {
            if (!value) {
                this.isLoading = false
            }
        },
    },
}
</script>

<style>
.modal-card {
  width: 100%; }
.modal-card .action-button-container {
  flex: 1; }

</style>